<template>
  <div ref="target-view" id="source-view" class="target-preview-inside cat-trans"
       v-html="getTargetContentInfo.convertStr">
  </div>
</template>

<script>
export default {
  name: "TargetPreview",
  data() {
    return {
      value: '选项1',
      flag: false,
      debounceName: "",
    };
  },
  watch: {
    getAppointPreview: {
      handler(val) {
        console.log(val,'####');
        if (val && val.convertStr) {
          let domArr = document.querySelectorAll('div[partType = target ][partIndex]')
          domArr.forEach(element => {
            if (element && element.getAttribute('partIndex') && parseInt(element.getAttribute('partIndex')) === parseInt(this.getPartIndex)) {
              element.innerHTML = val.convertStr
            }
          })
        }
      },
      deep: true
    },
    getTargetInfo: {
      handler(val) {
        if (!!val.targetTagFragmentVo) {
          let domArr = document.querySelectorAll(`span[type = 'target'][sid = '${val.sentId}']`)
          if (domArr[0]) {
            this.getLoopNode(domArr[0])
          } else {
            let keyDomArr = document.querySelectorAll(`span[type = 'target'][key = '${this.getSentCountInfo.key}']`)
            if (keyDomArr[0]) {
              this.getLoopNode(keyDomArr[0])
            }
          }
        }
      },
      deep: true
    }
  },
  computed: {
    getTargetContentInfo() {
      return this.$store.getters['editor/getFilePreviewContentInfo'];
    },
    //获取原译文修改
    getTargetInfo() {
      return this.$store.getters["editor/getPreviewInfo"].params;
    },
    // 获取指定页码的段落
    getAppointPreview() {
      return this.$store.getters["editor/getAppointPreview"];
    },
    // 获取修改的句子相关数据
    getSentCountInfo() {
      return this.$store.getters["editor/getSentCountInfo"];
    },
    // 获取预览页码
    getPartIndex() {
      return this.$store.getters["editor/getPartIndex"]
    },
  },
  methods: {
    // 查找出partIndex属性的节点
    getLoopNode(element) {
      if (element && element.parentNode && element.parentNode.nodeName === 'DIV' && element.parentNode.getAttribute('partIndex')) {
        let partIndex = element.parentNode.getAttribute('partIndex')
        if (partIndex) {
          this.$store.dispatch('editor/setWordPreview', partIndex)
        }
        return
      } else {
        this.getLoopNode(element.parentNode)
      }
    }

    // // 过滤出key不相等的
    // getArrDifSameValue(arr1, arr2) {
    //   let result = [];
    //   for (let i = 0; i < arr2.length; i++) {
    //     let obj = arr2[i];
    //     let key = '$' + '{' + obj.getAttribute('key') + '}'
    //     let isExist = false;
    //     for (let j = 0; j < arr1.length; j++) {
    //       let aj = arr1[j];
    //       let n = aj.atomKey;
    //       if (n == key) {
    //         isExist = true;
    //         break;
    //       }
    //     }
    //     if (!isExist) {
    //       result.push(obj);
    //     }
    //   }
    //   return result;
    // },
    // // 去重
    // removeDuplicateObj(arr) {
    //   const newArr = [];
    //   for (const t of arr) {
    //     if (newArr.find((c) => c.atomKey === t.atomKey)) {
    //       continue;
    //     }
    //     newArr.push(t);
    //   }
    //   return newArr;
    // },

  }
}
</script>

<style lang="less" scoped>
@import "assets/style.less";
</style>